<template lang="pug">
    nav.mainNav(ref="mainNav", @mousemove="positionLine()")
        div.mainNav--inner
            ul
                li
                    button(@click="goToRoute('Breathing')") Breathing
                li
                    button(@click="goToRoute('Feeling')") Feeling
                li
                    button(@click="goToRoute('Seeing')") Seeing
                li
                    button(@click="goToRoute('Thinking')") Thinking
                li
                    button(@click="goToRoute('Tasting')") Tasting
                li
                    button(@click="goToRoute('Moving')") Moving
                li.mainNav--line
        button.mainNav--close(@click="close()")
            svg(xmlns="http://www.w3.org/2000/svg", width="12", height="12", viewBox="0 0 48 48")
                path(fill="none", fill-rule="evenodd", stroke="#fff", stroke-width="2", d="M24 24L1 47l23-23L1 1l23 23zm0 0L47 1 24 24l23 23-23-23z", stroke-linecap="round", stroke-linejoin="round")
</template>
<script>
export default {
    data() {
        return {
        }
    },
    mounted() {
        TweenLite.to('.mainNav--line', 1.5, { height: '72%', delay: .2, yPercent:'-50', opacity: 1, ease: Power4.easeOut })
    },
    methods: {
        close() {
            this.$store.commit('mainNav', false)
            if (!this.$store.state.draggerOpen) {
                this.$store.commit('anatomy', true)
            }
        },
        positionLine() {
            TweenMax.to('.mainNav--line', .22, { x: event.clientX , yPercent:'-50', ease: Power2.easeOut});
        },
        goToRoute(route) {
            let self = this
            event.target.parentNode.classList.add('is-active')

            self.close()
            TweenMax.to('.mainNav--line', 1, { opacity: 0, ease: Power2.easeOut});

            if (self.$route.name !== route) {
                self.$router.push({ name: route })
            }
        }
    },
    beforeDestroy() {
        console.log('killing line')
    }
}
</script>



// WEBPACK FOOTER //
// src/components/mainNav.vue